import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles } from 'actions';
import {
	GetSitesRequest,
	GetSiteDetailsRequest,
	GetSiteAttachmentsRequest,
	GetSiteDropdownsRequest,
	GetSitesIdsRequest,
	EditSiteDetailsRequest,
	CreateSiteRequest,
	DeleteSiteRequest,
	ExportSitesRequest,
	FileUpdateSitesSiteTrackerRequest,
	FileUpdateSitesCommitSiteTrackerRequest,
	ImportValidationsSiteTrackerRequest,
	GetAutocompleteFieldsRequest,
	// Attachments
	AddAttachmentsRequest,
	DownloadAttachmentsRequest,
	DownloadAttachmentRequest,
	RemoveAttachmentsRequest,
	RemoveAttachmentRequest,
	// Comments
	GetCommentsRequest,
	AddCommentRequest,
	// Options
	AddDropdownFieldRequest,
	RemoveDropdownFieldRequest,
	// Update
	UpdateSitesRequest,
	// Columns
	GetVisibleColumnsRequest,
	ChangeColumnVisibilityRequest,
	// Filters
	GetVisibleFiltersRequest,
	ChangeFilterVisibilityRequest,

} from '../requests/SiteTrackerRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_SITE_TRACKER = 'GET_SITE_TRACKER';
export const TOGGLE_SITE_TRACKER_DIALOG = 'TOGGLE_SITE_TRACKER_DIALOG';
export const GET_SITE_TRACKER_DETAILS = 'GET_SITE_TRACKER_DETAILS';
export const GET_SITE_TRACKER_ATTACHMENTS = 'GET_SITE_TRACKER_ATTACHMENTS';
export const GET_SITE_TRACKER_DROPDOWNS = 'GET_SITE_TRACKER_DROPDOWNS';
export const GET_SITES_IDS = 'GET_SITES_IDS';
export const TOGGLE_DELETE_SITE_TRACKER_DIALOG = 'TOGGLE_DELETE_SITE_TRACKER_DIALOG';
export const GET_SITE_TRACKER_AUTOCOMPLETE = 'GET_SITE_TRACKER_AUTOCOMPLETE';
export const TOGGLE_ATTACH_FILES_DIALOG = 'TOGGLE_ATTACH_FILES_DIALOG';
export const TOGGLE_DELETE_ATTACHMENTS_DIALOG = 'TOGGLE_DELETE_ATTACHMENTS_DIALOG';
export const TOGGLE_DELETE_ATTACHMENT_DIALOG = 'TOGGLE_DELETE_ATTACHMENT_DIALOG';
export const TOGGLE_OPTIONS_DIALOG = 'TOGGLE_OPTIONS_DIALOG';
export const TOGGLE_OPTIONS_FORM = 'TOGGLE_OPTIONS_FORM';
export const TOGGLE_FILE_UPDATE_SITES_DIALOG = 'TOGGLE_FILE_UPDATE_SITES_DIALOG';
export const TOGGLE_IMPORT_VALIDATIONS_DIALOG = 'TOGGLE_IMPORT_VALIDATIONS_DIALOG';
export const FILE_UPDATE_SITES_MESSAGE = 'FILE_UPDATE_SITES_MESSAGE';
export const TOGGLE_UPDATE_DIALOG = 'TOGGLE_UPDATE_DIALOG';
export const TOGGLE_UPDATE_CONFIRMATION = 'TOGGLE_UPDATE_CONFIRMATION';
export const GET_COMMENTS = 'GET_COMMENTS';
export const ADD_DROPDOWN_FIELD = 'ADD_DROPDOWN_FIELD';
export const GET_VISIBLE_COLUMNS = 'GET_VISIBLE_COLUMNS';
export const GET_VISIBLE_FILTERS = 'GET_VISIBLE_FILTERS';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetSites = value => ({
	type: GET_SITE_TRACKER,
	sites: value
});

const onToggleSiteTrackerDialog = (visible, tableId) => ({
	type: TOGGLE_SITE_TRACKER_DIALOG,
	visible,
	tableId
});

const onGetSiteDetails = value => ({
	type: GET_SITE_TRACKER_DETAILS,
	siteDetails: value
});

const onGetSiteAttachments = value => ({
	type: GET_SITE_TRACKER_ATTACHMENTS,
	attachments: value
});

const onGetSiteDropdowns = value => ({
	type: GET_SITE_TRACKER_DROPDOWNS,
	dropdowns: value
});

const onGetSitesIds = value => ({
	type: GET_SITES_IDS,
	sitesIds: value
});

const onToggleDeleteSiteTrackerDialog = (visible, tableId) => ({
	type: TOGGLE_DELETE_SITE_TRACKER_DIALOG,
	visible,
	tableId
});

const onGetAutocompleteFields = value => ({
	type: GET_SITE_TRACKER_AUTOCOMPLETE,
	autocompleteFields: value
});

const onToggleAttachFileSiteTrackerDialog = (visible, tableId, title) => ({
	type: TOGGLE_ATTACH_FILES_DIALOG,
	visible,
	tableId,
	title
});

const onToggleDeleteAttachmentsDialog = (visible, tableId, title) => ({
	type: TOGGLE_DELETE_ATTACHMENTS_DIALOG,
	visible,
	tableId,
	title
});

const onToggleDeleteAttachmentDialog = (visible, tableId, id) => ({
	type: TOGGLE_DELETE_ATTACHMENT_DIALOG,
	visible,
	tableId,
	id
});

const onToggleOptionsSiteTrackerDialog = visible => ({
	type: TOGGLE_OPTIONS_DIALOG,
	visible
});

const onToggleOptionsSiteTrackerForm = (visible, dropdownLabel, dropdownName, dropdownValue, dropdownId) => ({
	type: TOGGLE_OPTIONS_FORM,
	visible,
	dropdownLabel,
	dropdownName,
	dropdownValue,
	dropdownId
});

const onToggleSiteTrackerFileUpdateSitesDialog = visible => ({
	type: TOGGLE_FILE_UPDATE_SITES_DIALOG,
	visible
});

const onToggleSiteTrackerImportValidationsDialog = visible => ({
	type: TOGGLE_IMPORT_VALIDATIONS_DIALOG,
	visible
});

const onFileUpdateSitesSiteTracker = value => ({
	type: FILE_UPDATE_SITES_MESSAGE,
	fileUpdateSitesMessage: value
});

const onToggleSiteTrackerUpdateDialog = visible => ({
	type: TOGGLE_UPDATE_DIALOG,
	visible
});

const onToggleSiteTrackerUpdateConfirmation = (visible, fieldType, fieldTypeValue, fieldName, fieldValue, phase) => ({
	type: TOGGLE_UPDATE_CONFIRMATION,
	visible,
	fieldType,
	fieldTypeValue,
	fieldName,
	fieldValue,
	phase
});

const onGetComments = value => ({
	type: GET_COMMENTS,
	comments: value
});

const onAddDropdownField = value => ({
	type: ADD_DROPDOWN_FIELD,
	newDropdownField: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetSites = (userId, role) => async dispatch => {
	await GetSitesRequest(userId, role)
		.then(response => {
			dispatch(onGetSites(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleSiteTrackerDialog = (visible, tableId) => dispatch => {
	dispatch(onToggleSiteTrackerDialog(visible, tableId));
};

export const GetSiteDetails = (userId, tableId) => async dispatch => {
	await GetSiteDetailsRequest(userId, tableId)
		.then(response => {
			dispatch(onGetSiteDetails(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetSiteAttachments = (userId, tableId) => async dispatch => {
	await GetSiteAttachmentsRequest(userId, tableId)
		.then(response => {
			dispatch(onGetSiteAttachments(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetSiteDropdowns = (
	userId,
	tableId
) => async dispatch => {
	await GetSiteDropdownsRequest(userId, tableId)
		.then(response => {
			dispatch(onGetSiteDropdowns(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetSitesIds = (mocnActivationDateA, phase) => async dispatch => {
	await GetSitesIdsRequest(mocnActivationDateA, phase)
		.then(response => {
			dispatch(onGetSitesIds(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const EditSiteDetails = siteTrackerDto => async dispatch => {
	await EditSiteDetailsRequest(siteTrackerDto)
		.then(response => {
			dispatch(GetSites());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const CreateSite = siteTrackerDto => async dispatch => {
	await CreateSiteRequest(siteTrackerDto)
		.then(response => {
			dispatch(GetSites());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleDeleteSiteTrackerDialog = (visible, tableId) => dispatch => {
	dispatch(onToggleDeleteSiteTrackerDialog(visible, tableId));
};

export const DeleteSite = (userId, tableId) => async dispatch => {
	await DeleteSiteRequest(userId, tableId)
		.then(response => { })
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ExportSitesAll = (userId, role) => async dispatch => {
	await ExportSitesRequest(userId, role, "all")
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ExportSitesByType = (userId, role) => async dispatch => {
	await ExportSitesRequest(userId, role, "byType")
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ExportSitesVMO2 = (userId, role) => async dispatch => {
	await ExportSitesRequest(userId, role, "VMO2")
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetAutocompleteFields = siteId => async dispatch => {
	await GetAutocompleteFieldsRequest(siteId)
		.then(response => {
			dispatch(onGetAutocompleteFields(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const AddAttachments = (userId, tableId, title, folderPath, image) => async dispatch => {
	await AddAttachmentsRequest(userId, tableId, title, folderPath, image)
		.then(response => {
			dispatch(GetSiteAttachments(userId, tableId));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const UploadAttachments = (userId, tableId, title, files, image) => async dispatch => {
	await UploadFiles(files)
		.then(response => {
			dispatch(AddAttachments(userId, tableId, title, response.data, image));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleAttachFileSiteTrackerDialog = (visible, tableId, title) => dispatch => {
	dispatch(onToggleAttachFileSiteTrackerDialog(visible, tableId, title));
};

export const DownloadAttachments = (userId, tableId, title) => async dispatch => {
	await DownloadAttachmentsRequest(userId, tableId, title)
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const DownloadAttachment = (userId, id) => async dispatch => {
	await DownloadAttachmentRequest(userId, id)
		.then(response => {
			dispatch(DownloadFile(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ToggleDeleteAttachmentsDialog = (visible, tableId, title) => dispatch => {
	dispatch(onToggleDeleteAttachmentsDialog(visible, tableId, title));
};

export const ToggleDeleteAttachmentDialog = (visible, tableId, id) => dispatch => {
	dispatch(onToggleDeleteAttachmentDialog(visible, tableId, id));
};

export const ToggleOptionsSiteTrackerDialog = visible => dispatch => {
	dispatch(onToggleOptionsSiteTrackerDialog(visible));
};

export const ToggleOptionsSiteTrackerForm = (visible, dropdownLabel, dropdownName, dropdownValue, dropdownId) => dispatch => {
	dispatch(onToggleOptionsSiteTrackerForm(visible, dropdownLabel, dropdownName, dropdownValue, dropdownId));
};

export const ToggleSiteTrackerFileUpdateSitesDialog = visible => dispatch => {
	dispatch(onToggleSiteTrackerFileUpdateSitesDialog(visible));
	dispatch(onFileUpdateSitesSiteTracker(''));
};

export const ToggleSiteTrackerImportValidationsDialog = visible => dispatch => {
	dispatch(onToggleSiteTrackerImportValidationsDialog(visible));
};

export const ToggleSiteTrackerUpdateDialog = visible => dispatch => {
	dispatch(onToggleSiteTrackerUpdateDialog(visible));
};

export const ToggleSiteTrackerUpdateConfirmation = (visible, fieldType, fieldTypeValue, fieldName, fieldValue, phase) => dispatch => {
	dispatch(onToggleSiteTrackerUpdateConfirmation(visible, fieldType, fieldTypeValue, fieldName, fieldValue, phase));
};

export const FileUpdateSitesSiteTracker = (userId, filePath,) => async dispatch => {
	await FileUpdateSitesSiteTrackerRequest(userId, filePath)
		.then(response => {
			dispatch(onFileUpdateSitesSiteTracker(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const UploadFileUpdateSitesSiteTracker = (userId, file) => async dispatch => {
	await UploadFile(file)
		.then(response => {
			dispatch(FileUpdateSitesSiteTracker(userId, response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const FileUpdateSitesCommitSiteTracker = (userId, proximitiesUpdate) => async dispatch => {
	await FileUpdateSitesCommitSiteTrackerRequest(userId, proximitiesUpdate)
		.then(response => {
			dispatch(enqueueSnackbar({ message: "Changes applied", options: { variant: "info" } }));
			dispatch(onFileUpdateSitesSiteTracker(''));
			dispatch(onToggleSiteTrackerFileUpdateSitesDialog(false));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const ImportValidationsSiteTracker = (userId, filePath,) => async dispatch => {
	await ImportValidationsSiteTrackerRequest(userId, filePath)
		.then(response => {
			// dispatch(onFileUpdateSitesSiteTracker(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const UploadImportValidationsSiteTracker = (userId, file) => async dispatch => {
	await UploadFile(file)
		.then(response => {
			dispatch(ImportValidationsSiteTracker(userId, response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const RemoveAttachments = (userId, tableId, title) => async dispatch => {
	await RemoveAttachmentsRequest(userId, tableId, title)
		.then(response => {
			dispatch(GetSiteAttachments(userId, tableId));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const RemoveAttachment = (userId, tableId, id) => async dispatch => {
	await RemoveAttachmentRequest(userId, id)
		.then(response => {
			dispatch(GetSiteAttachments(userId, tableId));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

// Comments
export const GetComments = (tableId) => async dispatch => {
	await GetCommentsRequest(tableId)
		.then(response => {
			dispatch(onGetComments(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const AddComment = (userId, tableId, title, comment) => async dispatch => {
	await AddCommentRequest(userId, tableId, title, comment)
		.then(response => {
			dispatch(GetComments(tableId));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

// Options
export const AddDropdownField = (userId, name, value, relations) => async dispatch => {
	await AddDropdownFieldRequest(userId, name, value, relations)
		.then(response => {
			dispatch(GetSiteDropdowns());
			dispatch(onAddDropdownField(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const RemoveDropdownField = (userId, name, value, id, relations) => async dispatch => {
	await RemoveDropdownFieldRequest(userId, name, value, id, relations)
		.then(response => {
			dispatch(GetSiteDropdowns());
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

// Update
export const UpdateSites = (userId, role, fieldType, fieldTypeValue, fieldName, fieldValue, phase) => async dispatch => {
	await UpdateSitesRequest(userId, fieldType, fieldTypeValue, fieldName, fieldValue, phase)
		.then(response => {
			dispatch(GetSites(userId, role));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

// Columns
const onGetVisibleColumns = (value) => ({
	type: GET_VISIBLE_COLUMNS,
	visibleColumns: value
});

export const GetVisibleColumns = (userId, tableName) => async (dispatch) => {
	await GetVisibleColumnsRequest(userId, tableName).then(response => {
		dispatch(onGetVisibleColumns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ChangeColumnVisibility = (changeColumn) => async (dispatch) => {
	await ChangeColumnVisibilityRequest(changeColumn).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Filters
const onGetVisibleFilters = (value) => ({
	type: GET_VISIBLE_FILTERS,
	visibleFilters: value
});

export const GetVisibleFilters = (userId, tableName) => async (dispatch) => {
	await GetVisibleFiltersRequest(userId, tableName).then(response => {
		dispatch(onGetVisibleFilters(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ChangeFilterVisibility = (changeColumn) => async (dispatch) => {
	await ChangeFilterVisibilityRequest(changeColumn).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
